import { Component, OnInit } from '@angular/core';
import { LoaderService } from '../../utils/loader.service';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute, Params }     from '@angular/router';
import { FormBuilder, Validators, FormArray, FormGroup, FormControl } from '@angular/forms';
import { AdminService } from '../admin.service';
import { AuthService } from '../../authentication/auth.service';

declare var $:any;

@Component({
  selector: 'app-profile-update',
  templateUrl: './profile-update.component.html',
  styleUrls: ['./profile-update.component.scss']
})
export class ProfileUpdateComponent implements OnInit {
  
  printProcessViewList: any;
  machineDetailsViewArray: any;
  industryViewList: any;
  certificationsViewList: any;
  profileDetails: any;
  keyword:any;

  profileDetailForm:FormGroup;
  profileDetailFormSubmitted = false;
  companyDetailForm:FormGroup;
  companyDetailFormSubmitted = false;

  verifyMobileForm:FormGroup;
  verifyMobileSubmitted = false;

  printProcesses: any;
  selectedPrintProcesses: any;
  printProcessDropdownSettings = {};
  newPrintProcessForm:FormGroup;
  printProcessForm:FormGroup;
  
  machineForm:FormGroup;
  machines: any;
  machineDetailsArray:any;
  brands:any;  
  masterSpecs:any;
  machineUnits:any;
  machineFormSubmitted = false;
  isActiveMachineSubmit = false;

  vendorIndustries: any;
  selectedVendorIndustries: any;
  industryDropdownSettings = {};
  newIndustryForm:FormGroup;
  industriesForm:FormGroup;
  industriesFormSubmitted = false;

  certificates: any;
  selectedCertificates: any;
  certificatesDropdownSettings = {};
  newCertificateForm:FormGroup;
  certificateForm:FormGroup;

  passwordForm:FormGroup;
  passwordFormSubmitted = false;

  constructor(    
    public adminService: AdminService,
    private loaderService: LoaderService,
    private toastr: ToastrService,
    public router: Router,
    public route: ActivatedRoute,
    private fb: FormBuilder,
    private authService: AuthService,
  ) { }

  ngOnInit() {
    this.keyword = "name";
    this.machineDetailsArray = [];
    // set the profileDetailForm
    this.profileDetailForm = this.fb.group({
      'name': [ "", Validators.required ],
      "state": ["", Validators.required],
      "country": ["", Validators.required],
      "gender": ["", Validators.required],
      "language": ["", Validators.required]
    });

    // set the profileDetailForm
    this.companyDetailForm = this.fb.group({
      'company_name': [ "", Validators.required ],
      'website_url': "",
      'industry_type': [ "", Validators.required ],
      'established_in_year': [ "", [Validators.required] ],
      'proprietor_first_name': [ "", Validators.required ],
      'proprietor_last_name': [ "", Validators.required ],
      'proprietor_email': [ "", [ Validators.required, Validators.email] ],
      'no_of_employees': ["", Validators.required],
      'last_year_revenue': [0, Validators.required],
      "gst_number": ["", Validators.required],
      "pan_number": ["", Validators.required],
      "address_id": ["", Validators.required],
      "pin_code": ["", Validators.required], 
      "address": ["", Validators.required],
      "city": ["", Validators.required],
      "state": ["", Validators.required],
      "country": ["", Validators.required]
    });

    this.verifyMobileForm = this.fb.group({
      'contact_no': ["", Validators.required],
      'otp': ""
    });

    this.printProcessForm = this.fb.group({
      'selectedPrintProcesses': [],
      'vendor_print_processes_attributes': this.fb.array([])
    });

    this.newPrintProcessForm= this.fb.group({
      'new_print_process_name': [ "", Validators.required],
    });

    this.printProcessDropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      allowSearchFilter: true,
      enableCheckAll: false,
    };

    this.loaderService.display(true);
    this.adminService.getCompanyDetails().subscribe(
       res => {
        this.profileDetails = res;
        this.loaderService.display(false);
       }, err => {
        for(let i in err.error.errors){
          this.toastr.error(err.error.errors[i]);
        }
      }
    );

    this.adminService.getCapabilityDetails().subscribe(
       res => {
        this.printProcessViewList = res.print_processes;
        this.industryViewList = res.vendor_industry_clients;
        this.certificationsViewList = res.certifications;
        console.log(this.industryViewList);
       }, err => {
        for(let i in err.error.errors){
          this.toastr.error(err.error.errors[i]);
        }
      }
    );
    
    this.setMachineFields();
    this.adminService.getVendorOwnedMachines().subscribe(
       res => {
        this.machineDetailsViewArray = res;
        this.machineDetailsArray = res;
       }, err => {
        for(let i in err.error.errors){
          this.toastr.error(err.error.errors[i]);
        }
      }
    );

    this.industriesForm = this.fb.group({
      'selectedVendorIndustries': [],
      'vendor_industries_clients_attributes': this.fb.array([])
    });

    this.newIndustryForm= this.fb.group({
      'new_industry_name': [ "", Validators.required],
    });

    this.industryDropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'display_name',
      allowSearchFilter: true,
      enableCheckAll: false,
    };

    this.certificateForm = this.fb.group({
      'selectedCertificates': [],
      'vendor_certifications_attributes': this.fb.array([])
    });

    this.newCertificateForm= this.fb.group({
      'new_certificate_name': [ "", Validators.required],
    });

    this.certificatesDropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      allowSearchFilter: true,
      enableCheckAll: false,
    };

    this.passwordForm = this.fb.group({
      'current_password': [ "", Validators.required ],
      'password': [ "", Validators.required ],
      'password_confirmation': [ "", Validators.required ],
    });
  }

  get f() { return this.profileDetailForm.controls; }
  get cd() { return this.companyDetailForm.controls; }
  get cpd() { return this.verifyMobileForm.controls; }
  get mf() { return this.machineForm.controls; }
  get pf() { return this.passwordForm.controls; }
  
  
  setProfileDetailsForm(){
    this.profileDetailFormSubmitted = false;
    this.profileDetailForm.reset();
    this.profileDetailForm.controls['name'].setValue(this.profileDetails.name);
    this.profileDetailForm.controls['state'].setValue(this.profileDetails.state);
    this.profileDetailForm.controls['country'].setValue(this.profileDetails.country);
    this.profileDetailForm.controls['gender'].setValue(this.profileDetails.gender);
    this.profileDetailForm.controls['language'].setValue(this.profileDetails.language);
  }

  submitProfileDetails(){
    this.profileDetailFormSubmitted = true;
    if (this.profileDetailForm.invalid) {
      return;
    }

    let data = this.profileDetailForm.value;
    let formData = new FormData();

    formData.append('user[name]', data.name);
    formData.append('user[state]', data.state);
    formData.append('user[country]', data.country);

    this.adminService.updateProfileDetails(formData).subscribe(
      res => {
        this.profileDetails = res;
        $("#profileDetailModal").modal('hide');
        
        this.toastr.success("Successfully updated the profile details.");
        this.loaderService.display(false);
      
      }, err => {
        
        this.loaderService.display(false);
        for(let i in err.error.errors){
          this.toastr.error(err.error.errors[i]);
        }
      }
    );    
  }

  setCompanyDetailsForm(){
    this.companyDetailFormSubmitted = false;
    this.companyDetailForm.reset();

    this.companyDetailForm.controls['company_name'].setValue(this.profileDetails.company_detail.company_name)
    this.companyDetailForm.controls['website_url'].setValue(this.profileDetails.company_detail.website_url)
    this.companyDetailForm.controls['industry_type'].setValue(this.profileDetails.company_detail.industry_type)
    this.companyDetailForm.controls['established_in_year'].setValue(this.profileDetails.company_detail.established_in_year)
    this.companyDetailForm.controls['proprietor_first_name'].setValue(this.profileDetails.company_detail.proprietor_first_name)
    this.companyDetailForm.controls['proprietor_last_name'].setValue(this.profileDetails.company_detail.proprietor_last_name)
    this.companyDetailForm.controls['proprietor_email'].setValue(this.profileDetails.company_detail.proprietor_email)
    this.companyDetailForm.controls['no_of_employees'].setValue(this.profileDetails.company_detail.no_of_employees)
    this.companyDetailForm.controls['last_year_revenue'].setValue(this.profileDetails.company_detail.last_year_revenue)
    this.companyDetailForm.controls['gst_number'].setValue(this.profileDetails.company_detail.gst_number)
    this.companyDetailForm.controls['pan_number'].setValue(this.profileDetails.company_detail.pan_number)
    this.companyDetailForm.controls['address'].setValue(this.profileDetails.primary_address.address)
    this.companyDetailForm.controls['pin_code'].setValue(this.profileDetails.primary_address.pin_code)
    this.companyDetailForm.controls['address_id'].setValue(this.profileDetails.primary_address.id)
    this.companyDetailForm.controls['city'].setValue(this.profileDetails.primary_address.city)
    this.companyDetailForm.controls['state'].setValue(this.profileDetails.primary_address.state)
    this.companyDetailForm.controls['country'].setValue(this.profileDetails.primary_address.country)
  }

  
  submitCompanyDetails(){
    this.companyDetailFormSubmitted = true;
    if (this.companyDetailForm.invalid) {
      return;
    }
    this.adminService.updateCompanyDetails(this.companyDetailForm.value).subscribe(
      res => {
        this.profileDetails = res;
        $("#companyDetailModal").modal('hide');
        
        this.toastr.success("Successfully updated the company details.");
        this.loaderService.display(false);
       
       }, err => {
        
        this.loaderService.display(false);
        for(let i in err.error.errors){
          this.toastr.error(err.error.errors[i]);
        }
      }
    );    
  }

  setVerifyMobileForm(){
    this.verifyMobileSubmitted = false;
    this.verifyMobileForm.reset();
    this.verifyMobileForm.controls['contact_no'].setValue(this.profileDetails.phone_number);
  }

  sendOtp(){
    this.verifyMobileSubmitted = true;
    if (this.verifyMobileForm.invalid) {
      return;
    }

    if(this.profileDetails.phone_number != this.verifyMobileForm.value.contact_no) {
      this.loaderService.display(true);
      this.adminService.sendOTP({contact_no: this.verifyMobileForm.value.contact_no}).subscribe(
        res =>{
          $("#contactDetailModal").modal('hide');
          $("#submitOtpModal").modal('show');
          this.loaderService.display(false);
        }, err =>{
          this.toastr.error(err.error.error);
          this.loaderService.display(false);
        }
      )
    }
  }

  setOtpForm(){
    this.verifyMobileSubmitted = false;
    this.verifyMobileForm.controls['otp'].setValue("");
  }

  wrongNumber(){
    $("#submitOtpModal").modal('hide');
    this.verifyMobileSubmitted = false;
    $("#contactDetailModal").modal('show');
  }

  submitOtp(){
    if(this.verifyMobileForm.value.otp.length < 4){
      this.loaderService.display(true);
      this.adminService.submitOTP(this.verifyMobileForm.value).subscribe(
        res =>{
          $("#submitOtpModal").modal('hide');
          this.profileDetails.phone_number = this.verifyMobileForm.value.contact_no;
          this.loaderService.display(false);
        }, err =>{
          this.toastr.error(err.error.error);
          this.loaderService.display(false);
        }
      )
    }else{
      alert("please enter the 4 digit otp.")
    }
    
  }

  setPrintProcessForm(){
    // setup print process value
    var selectedPrintProcessResponse = []
    var self = this
    this.selectedPrintProcesses = [];
    this.loaderService.display(true);

    this.adminService.getPrintProcesses().subscribe(
       res => {
        this.printProcesses = res;
        this.loaderService.display(false);
       }, err => {
        this.loaderService.display(false);
        for(let i in err.error.errors){
          this.toastr.error(err.error.errors[i]);
        }
      }
    );

    this.printProcessViewList.map(function(object){
      self.setValuePrintProcess(object)
      selectedPrintProcessResponse.push({id: object.id, name: object.name});
    });

    this.selectedPrintProcesses = selectedPrintProcessResponse;
    this.printProcessForm.controls['selectedPrintProcesses'].setValue(this.selectedPrintProcesses)
  }

  // print process related functions
  onPrintProcessSelect(item: any) {
    this.setValuePrintProcess(item);
    this.selectedPrintProcesses.push({id: item.id, name: item.name})
  }

  onPrintProcessDeselect(item: any) {
    this.removePrintProcess(this.printProcessForm.value.vendor_print_processes_attributes.findIndex(x => x.id == item.id))
  }

  addPrintProcess() {
    (this.printProcessForm.get('vendor_print_processes_attributes') as FormArray).push(this.fb.group({
      print_process_id:  ["", Validators.required],
      print_process_name:  ["", Validators.required],
    }));
  }

  setValuePrintProcess(item) {
    (this.printProcessForm.get('vendor_print_processes_attributes') as FormArray).push(this.fb.group({
      print_process_id:  [item.id, Validators.required],
      print_process_name:  [item.name, Validators.required],
    }));
  }

  removePrintProcess(idx) {
    (this.printProcessForm.get('vendor_print_processes_attributes') as FormArray).removeAt(idx);
  }

  submitNewPrintProcess(){
    var sampleArray = this.printProcesses.splice(1, this.printProcesses.length+1);
    var name = this.newPrintProcessForm.value.new_print_process_name;
    sampleArray.push({id: 0, name: name});
    this.printProcesses = sampleArray;
    this.selectedPrintProcesses.push({id: 0, name: name})
    this.setValuePrintProcess({id: 0, name: name});
    this.printProcessForm.controls['selectedPrintProcesses'].setValue(this.selectedPrintProcesses)
    $("#newPrintProcessFormModal").modal('hide');
  }

  setNewPrintProcessForm(){
    this.newPrintProcessForm.reset();
  }

  submitPrintProcessForm(){
    let formData = new FormData();
    let name, brandName;
    let errors = [];
    this.loaderService.display(true);

    // setup the print process data
    if(this.printProcessForm.get('vendor_print_processes_attributes').value.length > 0){
      for(var ele of this.printProcessForm.get('vendor_print_processes_attributes').value){
        formData.append('vendor[vendor_print_processes_attributes][][print_process_name]',  ele.print_process_name)
      }
    }else{
      errors.push({message: "Please Select atleast 1 Manufacturing Process."})
    }

    // check if any error exists
    // if yes, show them to users
    if(errors.length > 0){
      for(var ele of errors){
        this.toastr.error(ele.message);
      }
      this.loaderService.display(false);
      return;
    }

    this.adminService.updatePrintProcessDetails(formData).subscribe(
      res => {
        this.printProcessViewList = res.print_processes;
        $("#printProcessModal").modal('hide');
        this.toastr.success("Capability Details saved successfully!");
        this.loaderService.display(false);
      
      }, err => {
        this.loaderService.display(false);
        if(err.error.message){
          this.toastr.error(err.error.message);
        }else{
          for(let i in err.error.errors){
            this.toastr.error(err.error.errors[i]);
          }
        } 
      }
    );
  }


  // machine related functions
  setMachineData(){
    this.loaderService.display(true);
    
    this.setMachineFields();

    this.adminService.getMasterSpecs().subscribe(
      res => {
        this.masterSpecs = res;
      }, err => {
        this.loaderService.display(false);
        for(let i in err.error.errors){
          this.toastr.error(err.error.errors[i]);
        }
      }
    );

    this.adminService.getMachineUnits().subscribe(
      res => {
        this.machineUnits = res;
        this.loaderService.display(false);
      }, err => {
        this.loaderService.display(false);
        for(let i in err.error.errors){
          this.toastr.error(err.error.errors[i]);
        }
      }
    );
  }

  submitMachineDetails(){
    this.machineFormSubmitted = true;

    if(this.machineForm.valid){
      var formValue = this.machineForm.value;
      var master_spec, machine_unit, name, brandName;
      var machine_spec = [];
      
      if(formValue.vom_specifications.length > 0){
        formValue.vom_specifications.forEach(function(item, index){
          master_spec = item.master_specification_name.name || item.master_specification_name;
          machine_unit = item.machine_specification_unit_name.name || item.machine_specification_unit_name;
          
          machine_spec.push({
            master_specification_name: master_spec,
            machine_capacity: item.machine_capacity,
            machine_specification_unit_name: machine_unit,
          })
        })

        name = formValue.machine_name.name || formValue.machine_name;
        brandName = formValue.brand_name.name || formValue.brand_name;

        this.machineDetailsArray.push({
          vendor_machine_name: name,
          brand_name: brandName,
          model_number: formValue.model_number,
          number_of_machines: formValue.number_of_machines,
          spare_capacity: formValue.spare_capacity,
          machine_speciality: formValue.machine_speciality,
          vom_specifications: machine_spec
        })

        this.setMachineFields();
        this.machineFormSubmitted = false;
        this.isActiveMachineSubmit = true;
      }else{
        this.toastr.error("please add atleast 1 specs");
      }
    }
  }

  deleteFromMachineArray(idx){
    this.machineDetailsArray.splice(idx, 1);
    this.isActiveMachineSubmit = true;
  }

  setMachineFields(){
    this.machineForm = this.fb.group({
      'machine_name':  ["", Validators.required],
      'brand_name':  ["", Validators.required],
      'machine_speciality':  "",
      'model_number':  ["", Validators.required],
      'number_of_machines':  ["", Validators.required],
      'spare_capacity':  ["", Validators.required],
      'vom_specifications':  this.fb.array([]),
    })
    this.addMachineSpec();
  }

  addMachineSpec() {
    (this.machineForm.get('vom_specifications') as FormArray).push(this.fb.group({
      master_specification_name:  ["", Validators.required],
      machine_capacity:  ["", Validators.required],
      machine_specification_unit_name:  ["", Validators.required],
    }));
  }

  setValueMachineSpec(item) {
    (this.machineForm.get('vom_specifications') as FormArray).push(this.fb.group({
      master_specification_name:  ["", Validators.required],
      machine_capacity:  ["", Validators.required],
      machine_specification_unit_name:  ["", Validators.required],
    }));
  }

  removeMachineSpec(idx) {
    (this.machineForm.get('vom_specifications') as FormArray).removeAt(idx);
    this.isActiveMachineSubmit = true;
  }

  onChangeMachineSearch(val: string) {
    this.adminService.searchMachines(val).subscribe(
      res => {
        this.machines = res;
      }, 
      err => {
        this.loaderService.display(false);
        for(let i in err.error.errors){
          this.toastr.error(err.error.errors[i]);
        }
     });
  }

  onMachineSelectSetSpecs(item){
    this.loaderService.display(true);
    this.adminService.getMachineRelatedSpecs(item.id).subscribe(
      res => {
        // if(res.length > 0){
          this.masterSpecs = res;
        // }
        this.loaderService.display(false);
      },
      err => {
        this.loaderService.display(false);
        for(let i in err.error.errors){
          this.toastr.error(err.error.errors[i]);
        }
      }
    );
  }

  onChangeBrandSearch(val: string) {
    this.adminService.searchBrands(val).subscribe(
      res => {
        this.brands = res;
      },
      err => {
        this.loaderService.display(false);
        for(let i in err.error.errors){
          this.toastr.error(err.error.errors[i]);
        }
      }
    );
  }

  submitMachineAllDetails(){
    let formData = new FormData();
    let name, brandName;
    let errors = [];

    // setup the machine data
    if(this.machineDetailsArray.length > 0){
      for(var ele of this.machineDetailsArray){
        formData.append('vendor[vendor_owned_machines_attributes][][machine_name]', ele.vendor_machine_name)
        formData.append('vendor[vendor_owned_machines_attributes][][brand_name]', ele.brand_name)
        formData.append('vendor[vendor_owned_machines_attributes][][machine_speciality]',  ele.machine_speciality)
        formData.append('vendor[vendor_owned_machines_attributes][][model_number]',  ele.model_number)
        formData.append('vendor[vendor_owned_machines_attributes][][spare_capacity]',  ele.spare_capacity)
        formData.append('vendor[vendor_owned_machines_attributes][][number_of_machines]',  ele.number_of_machines)

        for(var i of ele.vom_specifications){
          formData.append('vendor[vendor_owned_machines_attributes][][vom_specifications][][master_specification_name]',  i.master_specification_name)
          formData.append('vendor[vendor_owned_machines_attributes][][vom_specifications][][machine_capacity]',  i.machine_capacity)
          formData.append('vendor[vendor_owned_machines_attributes][][vom_specifications][][machine_specification_unit_name]',  i.machine_specification_unit_name)
        }
      }
    }else{
      errors.push({message: "Please add atleast 1 machine to submit this form"})
    }

    // check if any error exists
    // if yes, show them to users
    if(errors.length > 0){
      for(var ele of errors){
        this.toastr.error(ele.message);
      }
      this.loaderService.display(false);
      return;
    }

    this.adminService.updateMachineDetails(formData).subscribe(
      res => {
        this.machineDetailsViewArray = res;
        this.machineDetailsArray = res;

        $("#machineFormModal").modal('hide');
        this.toastr.success("Machine details saved successfully!");
        this.loaderService.display(false);
      
      }, err => {
        this.loaderService.display(false);
        if(err.error.message){
          this.toastr.error(err.error.message);
        }else{
          for(let i in err.error.errors){
            this.toastr.error(err.error.errors[i]);
          }
        } 
      }
    );
  }






  
  // industry related functions
  setIndustryForm(){
    var selectedVendorIndustryResponse = []
    var self = this
    this.selectedVendorIndustries = [];
    this.industriesFormSubmitted = false;
    this.loaderService.display(true);

    this.adminService.getIndustries().subscribe(
       res => {
        this.vendorIndustries = res;
        this.loaderService.display(false);
       }, err => {
        this.loaderService.display(false);
        for(let i in err.error.errors){
          this.toastr.error(err.error.errors[i]);
        }
      }
    );

    // setup industries value
    this.industryViewList.map(function(ele){
      selectedVendorIndustryResponse.push({id: ele.id, display_name: ele.industry_name})
      self.setValueMasterClient(ele.id, ele.industry_name, ele.client_name)
    });

    this.selectedVendorIndustries = selectedVendorIndustryResponse;
    this.industriesForm.controls['selectedVendorIndustries'].setValue(this.selectedVendorIndustries) 
  }

  onIndustrySelect(item: any) {
    this.setValueMasterClient(item.id, item.display_name, "");
    this.selectedVendorIndustries.push({id: item.id, display_name: item.display_name})
  }

  onIndustryDeselect(item: any) {
    this.removeMasterClient(this.industriesForm.value.vendor_industries_clients_attributes.findIndex(x => x.id == item.id))
  }

  setValueMasterClient(id, industryName, ClientName) {
    (this.industriesForm.get('vendor_industries_clients_attributes') as FormArray).push(this.fb.group({
      id: id,
      industry_name: [industryName, Validators.required],
      client_name: [ClientName, Validators.required],
    }));
  }

  removeMasterClient(idx) {
    (this.industriesForm.get('vendor_industries_clients_attributes') as FormArray).removeAt(idx);
  }

  submitNewIndustry(){
    var sampleArray = this.vendorIndustries.splice(1, this.vendorIndustries.length+1);
    var name = this.newIndustryForm.value.new_industry_name;
    sampleArray.push({id: 0, name: name, display_name: name});
    this.vendorIndustries = sampleArray;
    this.selectedVendorIndustries.push({id: 0, display_name: name});
    this.industriesForm.controls['selectedVendorIndustries'].setValue(this.selectedVendorIndustries);
    this.setValueMasterClient(0, name,"");
    $("#newIndustryFormModal").modal('hide');
  }

  setNewIndustryForm(){
    this.newIndustryForm.reset();
  }

  submitIndustryForm(){
    let formData = new FormData();
    let errors = [];
    this.loaderService.display(true);
    this.industriesFormSubmitted = true;
    
    // setup the industries data
    if(this.industriesForm.get('vendor_industries_clients_attributes').value.length > 0){
      for(var ele of this.industriesForm.get('vendor_industries_clients_attributes').value){
        if(ele.industry_name.trim().length > 0 && ele.client_name.trim().length > 0){
          formData.append('vendor[vendor_industries_clients_attributes][][client_name]',  ele.client_name.trim())
          formData.append('vendor[vendor_industries_clients_attributes][][industry_name]',  ele.industry_name.trim())
        }else{
          errors.push({message: "Please enter atleast 1 client."})
        }
      }
    }else{
      errors.push({message: "Please Select atleast 1 Industry vertical."})
    }

    // check if any error exists
    // if yes, show them to users
    if(errors.length > 0){
      for(var ele of errors){
        this.toastr.error(ele.message);
      }
      this.loaderService.display(false);
      return;
    }

    this.adminService.updateIndustriesDetails(formData).subscribe(
      res => {
        this.industryViewList = res.vendor_industry_clients;
        $("#industryModal").modal('hide');
        this.toastr.success("Industries details saved successfully!");
        this.loaderService.display(false);
      
      }, err => {
        this.loaderService.display(false);
        if(err.error.message){
          this.toastr.error(err.error.message);
        }else{
          for(let i in err.error.errors){
            this.toastr.error(err.error.errors[i]);
          }
        } 
      }
    );
  }
  




  setCertificationForm(){
    var selectedcertificationResponse = []
    var self = this
    this.selectedCertificates = [];
    this.loaderService.display(true);

    this.adminService.getCertificates().subscribe(
      res => {
        this.certificates = res;
        this.loaderService.display(false);
      }, err => {

        this.loaderService.display(false);
        for(let i in err.error.errors){
          this.toastr.error(err.error.errors[i]);
        }
      }
    );

    this.certificationsViewList.map(function(object){
      self.setValueCertification(object)
      selectedcertificationResponse.push({id: object.id, name: object.name})
    });

    this.selectedCertificates = selectedcertificationResponse;
    this.certificateForm.controls['selectedCertificates'].setValue(this.selectedCertificates)
  }

  onCertificatesSelect(item: any) {
    this.setValueCertification(item);
    this.selectedCertificates.push({id: item.id, name: item.name})
  }

  onCertificatesDeselect(item: any) {
    this.removeCertification(this.certificateForm.value.vendor_certifications_attributes.findIndex(x => x.certification_id == item.id))
  }

  setValueCertification(item) {
    (this.certificateForm.get('vendor_certifications_attributes') as FormArray).push(this.fb.group({
      certification_id:  [item.id, Validators.required],
      certification_name:  [item.name, Validators.required],
    }));
  }

  removeCertification(idx) {
    (this.certificateForm.get('vendor_certifications_attributes') as FormArray).removeAt(idx);
  }

  submitNewCertificate(){
    var sampleArray = this.certificates.splice(1, this.certificates.length+1);
    var name = this.newCertificateForm.value.new_certificate_name;
    sampleArray.push({id: 0, name: name});
    this.certificates = sampleArray;
    this.selectedCertificates.push({id: 0, name: name});
    this.certificateForm.controls['selectedCertificates'].setValue(this.selectedCertificates);
    this.setValueCertification({id: 0, name: name});
    $("#newCertificateFormModal").modal('hide');
  }

  setNewCertificateForm(){
    this.newCertificateForm.reset();
  }

  submitCertificationForm(){
    let formData = new FormData();
    let errors = [];
    this.loaderService.display(true);
    
    // setup the certification data
    if(this.certificateForm.get('vendor_certifications_attributes').value.length > 0){
      for(var ele of this.certificateForm.get('vendor_certifications_attributes').value){
        formData.append('vendor[vendor_certifications_attributes][][certification_name]',  ele.certification_name)
      }
    }else{
      errors.push({message: "Please Select atleast 1 Certifications."})
    }

    // check if any error exists
    // if yes, show them to users
    if(errors.length > 0){
      for(var ele of errors){
        this.toastr.error(ele.message);
      }
      this.loaderService.display(false);
      return;
    }

    this.adminService.updateCertificationsDetails(formData).subscribe(
      res => {
        this.certificationsViewList = res.certifications;
        $("#certificateModal").modal('hide');
        this.toastr.success("Certifications saved successfully!");
        this.loaderService.display(false);
      
      }, err => {
        this.loaderService.display(false);
        if(err.error.message){
          this.toastr.error(err.error.message);
        }else{
          for(let i in err.error.errors){
            this.toastr.error(err.error.errors[i]);
          }
        } 
      }
    );
  }

  setPasswordForm(){
    this.passwordForm.reset();
    this.passwordFormSubmitted = false;
  }

  submitPasswordForm(){
    let formData = new FormData();
    let errors = [];
    // this.loaderService.display(true);
    this.passwordFormSubmitted = true;

    if(this.passwordForm.invalid){
      return
    }

    let data = this.passwordForm.value;

    if(data.password != data.password_confirmation){
      errors.push({message: "New password doesn't match with eachother"});
    }

    if(data.password.length < 6){
      errors.push({message: "Password must be atleast 6 digits."});
    }

    if(errors.length > 0){
      for(var ele of errors){
        this.toastr.error(ele.message);
      }
      this.loaderService.display(false);
      return;
    }
    
    formData.append('user[current_password]',  data.current_password)
    formData.append('user[password_confirmation]',  data.password_confirmation)
    formData.append('user[password]',  data.password)

    this.adminService.updateUserPassword(formData).subscribe(
      res => {
        $("#passwordModal").modal('hide');
        this.toastr.success("Updated the password successfully!");
        this.loaderService.display(false);
        this.authService.logOut();
        this.toastr.success("Logged out successfully.");
      }, err => {
        this.loaderService.display(false);
        for(let i in err.error){
          this.toastr.error(err.error[i]);
        }
      }
    );
  }

}
